"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const CenteredTag = (0, styled_components_1.default)(antd_1.Tag) `
	display: flex;
	align-items: center;
`;
const Tag = ({ ...tagProps }) => {
    return (0, jsx_runtime_1.jsx)(CenteredTag, { ...tagProps });
};
exports.Tag = Tag;
